export default "__VITE_ASSET__BfGOAgc1__"